import { graphql } from 'gatsby';

import { VideoPlayer } from '../VideoPlayer';

type ProductVideosProps = {
  videos: Queries.ProductVideosFragment['videos'];
};

export const ProductVideos = ({ videos }: ProductVideosProps) => (
  <div className={'product-videos'}>
    {videos?.map((video) => {
      if (!video) {
        return null;
      }

      return (
        <VideoPlayer
          key={video.id!}
          source={{
            type: 'video',
            sources: [
              {
                src: video.url!,
                provider: 'youtube',
              },
            ],
          }}
        />
      );
    })}
  </div>
);

export const query = graphql`
  fragment ProductVideos on STRAPI_PRODUCT {
    videos {
      id
      url
    }
  }
`;
